export const ExternalLinkSimpleIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.0396 5.56937C18.9847 5.43668 18.9034 5.31237 18.7955 5.2045C18.5758 4.98483 18.2879 4.875 18 4.875H12C11.3787 4.875 10.875 5.37868 10.875 6C10.875 6.62132 11.3787 7.125 12 7.125H15.284L9.7045 12.7045C9.26517 13.1438 9.26517 13.8562 9.7045 14.2955C10.1438 14.7348 10.8562 14.7348 11.2955 14.2955L16.875 8.71599V12C16.875 12.6213 17.3787 13.125 18 13.125C18.6213 13.125 19.125 12.6213 19.125 12V6C19.125 5.84746 19.0946 5.70201 19.0396 5.56937Z"
        fill="currentColor"
      />
    </svg>
  );
};
